<template>
  <div class="mt-8 w-full h-full bg-white">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'OrderView',
  data() {
    return {
      page: 1,
      limit: 20,
    };
  },
  mounted() {
    try {
      this.$store.dispatch('OrderModule/fetchAllOrders', { page: this.page, limit: this.limit });
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
};
</script>

<style scoped>

</style>
